import axios from "axios";
import {
  CLEAR_SEARCH_RESULTS,
  CREATE_TRACK,
  DELETE_TRACK,
  FETCH_TRACKS,
  SEARCH_ERROR,
  SEARCH_SUCCESS,
  TRACK_ERROR,
  UPDATE_TRACK,
} from "./types";

export const searchTrack = (searchText) => async (dispatch) => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/search?q=${searchText}`,
    );
    return dispatch({
      type: SEARCH_SUCCESS,
      payload: data.data && data.data.data ? data.data.data : data.data,
    });
  } catch (error) {
    return dispatch({
      type: SEARCH_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const clearSearchResults = () => (dispatch) => {
  dispatch({
    type: CLEAR_SEARCH_RESULTS,
  });
};

export const createTrack = (payload) => async (dispatch) => {
  try {
    const data = await axios.post(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/video-tracks`,
      payload,
    );
    return dispatch({
      type: CREATE_TRACK,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: TRACK_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const deleteTrack = (trackId) => async (dispatch) => {
  try {
    const data = await axios.delete(`
            ${process.env.REACT_APP_GOLANG_API}/api/v2/video-tracks/${trackId}`);
    return dispatch({
      type: DELETE_TRACK,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: TRACK_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const updateTrack = (payload, trackId) => async (dispatch) => {
  try {
    const data = await axios.patch(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/video-tracks/${trackId}`,
      payload,
    );
    return dispatch({
      type: UPDATE_TRACK,
      payload: data.data,
    });
  } catch (error) {
    console.log("error", error);
    return dispatch({
      type: TRACK_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const fetchTracks = ({ page = 1, perPage = 10 } = {}) => async (dispatch) => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/video-tracks?includeDraft=true|false&page=${page}&perPage=${perPage}&timestamp=${new Date().getTime()}`,
    );

    if (data.data.data === null) data.data.data = [];

    return dispatch({
      type: FETCH_TRACKS,
      payload: data.data,
    });
  } catch (error) {
    return dispatch({
      type: TRACK_ERROR,
      payload: error.response ? error.response.data.error : error.message,
    });
  }
};

export const setTracksError = (message) => (dispatch) => {
  return dispatch({
    type: TRACK_ERROR,
    payload: message,
  });
};
